(function () {
    class OrderDetailsComponent {
        constructor(
            moment
        ) {
            this.moment = moment;
            this.timeFormat = "HH:mm";
            this.orderPaymentTypeLookup = {
                [Dashboard.OrderPaymentType.PayInStore]: "Pay In Store",
                [Dashboard.OrderPaymentType.PayOnline]: "Pay Online",
                [Dashboard.OrderPaymentType.CreditCArdOnDelivery]: "Credit Card On Delivery",
                [Dashboard.OrderPaymentType.CashOnDelivery]: "Cash On Delivery",
                [Dashboard.OrderPaymentType.MobileMoney]: "Mobile Money"
            }
            this.timeSinceOrderPlaced = "now";
            this.timeUntilRequested = "now";
        }

        $doCheck() {
            if (!this.ngModel) {
                return;
            }
            this.paymentType = this.orderPaymentTypeLookup[this.ngModel.OrderPaymentTypeId] || "Unknown payment type";
            this.deliveryMethod = this.ngModel.IsCollect
                ? "Collect"
                : "Delivery";
            this.customerFullName = `${this.ngModel.CustomerFirstName} ${this.ngModel.CustomerLastName}`;
            this.updateHumanReadableDates();
        }

        validInstructionsExist() {
            if (!this.ngModel?.Instructions) {
                return false;
            }
            return !!this.ngModel.Instructions.trim().length;
        }

        shouldShowSystemInstructions() {
            if (!this.ngModel?.SystemInstructions) {
                return false;
            }
            if (!this.showSystemInstructions) {
                return false;
            }
            return !!this.ngModel.SystemInstructions.trim().length;
        }

        goBackToOrderList() {
            this.backToList();
        }

        updateHumanReadableDates(){
            this.updateTimeSinceOrderPlaced();
            this.updateTimeUntilRequested();
        }

        updateTimeSinceOrderPlaced() {
            if (!this.ngModel) {
                return;
            }
            this.timeSinceOrderPlaced = window.Dashboard.helpers.time.timeSince(this.ngModel.Date);
        }

        updateTimeUntilRequested() {
            if (!this.ngModel) {
                return;
            }
            const requestedTime = this.moment.utc(this.ngModel.CompletionTime || this.ngModel.RequestedForTime || this.ngModel.Date);
            this.requestedForTime = requestedTime.toISOString();
            this.timeUntilRequested = window.Dashboard.helpers.time.timeUntil(requestedTime);
        }

        isPaidOnline() {
            return this.ngModel?.OrderPaymentTypeId === Dashboard.OrderPaymentType.PayOnline;
        }

        hasVoucher() {
            return this.ngModel?.Voucher?.Amount > 0;
        }

        totalBeforeVoucher() {
            if (!this.ngModel) {
                return 0;
            }
            return this.ngModel.TotalAmount +
                (this.ngModel.DriverTip || 0) +
                (this.ngModel.DeliveryFee || 0);
        }
    }

    angular.module("dashboard")
        .component("orderUpOrderDetails", {
            templateUrl: "components/store/order-up/order-up-order-details.3d13b4f5.html",
            bindings: {
                ngModel: "<",
                backToList: "<",
                showSystemInstructions: "<"
            },
            controller: ["moment", OrderDetailsComponent]
        });
})();
